import { ProgramType, UserTargetTypes } from 'fitbeat.models';

export const WorkoutTargetConfig: {
  [type in ProgramType]: number;
} = {
  [ProgramType.GainMuscleAndStrengthGoal]: 90,
  [ProgramType.GetLeanAndFitGoal]: 90,
  [ProgramType.GetStrongAndFitGoal]: 90,
  [ProgramType.MobilityAndTone]: 90,
  [ProgramType.MuscleAndShred]: 90,
  [ProgramType.NotSet]: 0,
};

export const workoutMinutesTargetConfig: {
  decrease: number;
  increase: number;
  max: number;
  success: number;
  fail: number;
} = {
  decrease: -15,
  increase: 15,
  max: 200,
  success: 3,
  fail: 0,
};

export const validTargetRange: {
  [type in UserTargetTypes]: number
} = {
  [UserTargetTypes.Bodyweight]: 1,
  [UserTargetTypes.Musclemass]: 1,
  [UserTargetTypes.Bodyfat]: 0.1,
};
